// AppLayout.js (versión con Chat de WhatsApp para Admin)
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import logoNexusPequeno from '../logo.png';
import logoBlueRover from '../bluerover_logo.png';
import MeliQuestionsWidget from './MeliQuestionsWidget';

function AppLayout({ children, onLogout, navigateTo, currentView }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => setIsSidebarOpen(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  // Submenus para Administración
  const [isGarantiaSubmenuOpen, setIsGarantiaSubmenuOpen] = useState(false);
  const toggleGarantiaSubmenu = () => setIsGarantiaSubmenuOpen((prev) => !prev);
  const [isAdminSubmenuOpen, setIsAdminSubmenuOpen] = useState(false);
  const toggleAdminSubmenu = () => setIsAdminSubmenuOpen((prev) => !prev);

  // contenedores para la nueva seccion sucursales
  const [isSucursalesSubmenuOpen, setIsSucursalesSubmenuOpen] = useState(false);
  const toggleSucursalesSubmenu = () => setIsSucursalesSubmenuOpen((prev) => !prev);

  const { user } = useAuth();
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  
  // Nuevo contenedor: Ecommerce Submenu
  const [isEcommerceSubmenuOpen, setIsEcommerceSubmenuOpen] = useState(false);
  const toggleEcommerceSubmenu = () => {
    setIsEcommerceSubmenuOpen(!isEcommerceSubmenuOpen);
    // Asegurar que solo un menú principal está abierto
    setIsLogisticaSubmenuOpen(false); 
    setIsAutoAzurSubmenuOpen(false);
  };

  // Mantenemos Logística y AutoAzur como submenús anidados dentro de Ecommerce
  const [isLogisticaSubmenuOpen, setIsLogisticaSubmenuOpen] = useState(false);
  const toggleLogisticaSubmenu = () => {
    setIsLogisticaSubmenuOpen(!isLogisticaSubmenuOpen);
  };

  const [isAutoAzurSubmenuOpen, setIsAutoAzurSubmenuOpen] = useState(false);
  const toggleAutoAzurSubmenu = () => {
    setIsAutoAzurSubmenuOpen(!isAutoAzurSubmenuOpen);
  };
  // Fin de manejo de estados

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };

  // [ROLES]
  const role = (user?.rol || '').toString().trim().toLowerCase();
  const isRoleAdministrativo = role === 'administrativo' || role === 'administativo';
  const isRoleContador = role === 'contador'; 

  const getMenuItemClasses = (viewName) => {
    const baseClasses = "flex items-center p-3 rounded-lg transition duration-200 w-full text-left";
    const activeClasses = "bg-blue-600 text-white";
    const hoverClasses = "hover:bg-gray-700 hover:text-white";
    
    // MODIFICADO: Añadimos 'whatsapp-chat' a la lógica de 'administracion'
    const isActive = currentView === viewName || 
                     (viewName === 'administracion' && (currentView === 'certificado' || currentView === 'garantia' || currentView === 'owner-space' || currentView === 'users' || currentView === 'inventory' || currentView === 'whatsapp-chat')) ||
                     (viewName === 'ecommerce-main' && 
                      (currentView === 'ecommerce' || currentView === 'logistica' || currentView === 'guide-management' || 
                       currentView === 'picking' || currentView === 'picking-v2' || currentView === 'transfers' || currentView === 'autoazur-inventory-update')) ||
                     (viewName === 'sucursales' && currentView === 'sucursales');

    return `${baseClasses} ${isActive ? activeClasses : hoverClasses}`;
  };

  const getSubMenuItemClasses = (viewName) => {
    const baseClasses = "flex items-center p-2 rounded-lg text-sm transition duration-200 w-full text-left";
    const activeClasses = "bg-yellow-400 text-gray-900 font-semibold";
    const hoverClasses = "hover:bg-gray-700 hover:text-white";
    const isActive = currentView === viewName;
    return `${baseClasses} ${isActive ? activeClasses : hoverClasses}`;
  };

  // Helper to navigate and close the sidebar (useful on mobile)
  const navigateAndClose = (view) => {
    navigateTo(view);
    setIsSidebarOpen(false);
  };

  // [ADMINISTRATIVO] — Redirigir al iniciar sesión directo a "sucursales"
  useEffect(() => {
    if (isRoleAdministrativo && currentView !== 'sucursales') {
      navigateTo('sucursales');
      setIsSucursalesSubmenuOpen(true);
    }
  }, [isRoleAdministrativo, currentView, navigateTo]);

  // [CONTADOR] — Redirigir a Corte de Cajas si entra a algo fuera de su scope
  useEffect(() => {
    const allowed = ['sucursales', 'owner-space'];
    if (isRoleContador && !allowed.includes(currentView)) {
      navigateTo('sucursales');
      setIsSucursalesSubmenuOpen(true);
    }
  }, [isRoleContador, currentView, navigateTo]);

  // Mantener abierto el submenú sucursales para Administrativo/Contador
  useEffect(() => {
    if (isRoleAdministrativo || isRoleContador) setIsSucursalesSubmenuOpen(true);
  }, [isRoleAdministrativo, isRoleContador]);

  return (
    <div className="flex bg-gray-100 min-h-screen font-sans">
      {/* Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-30 md:hidden"
          onClick={() => setIsSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar (drawer) */}
      <aside
        className={`fixed inset-y-0 left-0 bg-gray-800 text-white flex flex-col shadow-lg transition-all duration-300 z-40 md:relative overflow-hidden ${isSidebarOpen ? 'w-80 translate-x-0' : 'w-0 -translate-x-full md:translate-x-0'}`}
        aria-label="Barra lateral de navegación"
      >
        <div className="w-80 flex flex-col h-full">
        <div className="p-4 flex items-center border-b border-gray-700">
          <button
            className="mr-2 text-gray-300 hover:text-white md:hidden"
            onClick={() => setIsSidebarOpen(false)}
            aria-label="Cerrar menú"
            title="Cerrar"
          >
            {/* X icon */}
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
          <img
            src={logoNexusPequeno}
            alt="NEXUS Logo"
            className="h-281 w-86"
            onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/40x40/cccccc/333333?text=LR" }}
          />
        </div>

        <div className="p-4 border-b border-gray-700">
          <p className="text-lg font-semibold">{user?.nombre || 'Usuario'}</p>
          <p className="text-sm text-gray-400">{user?.rol || 'Encargado'}</p>
        </div>

        <nav className="p-4 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 200px)' }}>
          <ul className="space-y-2">
            {/* Dashboard: oculto para administrativo y contador */}
            {(!isRoleAdministrativo && !isRoleContador) && (
              <li className="list-none">
                <button
                  onClick={() => navigateAndClose('dashboard')}
                  className={getMenuItemClasses('dashboard')}
                >
                  <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path></svg>
                  Dashboard
                </button>
              </li>
            )}

            {/* Administración (solo admin; de por sí oculto a otros roles) */}
            {user?.rol === 'admin' && !isRoleAdministrativo && !isRoleContador && (
              <li className="list-none">
                <button
                  onClick={toggleAdminSubmenu}
                  className={getMenuItemClasses('administracion')}
                >
                  <div className="flex items-center">
                    <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20"><path d="M4 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H4zm0 2h12v10H4V5zm2 2a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H7a1 1 0 01-1-1V7z"></path></svg>
                    Administración
                  </div>
                  <svg className={`w-4 h-4 transform transition-transform duration-200 ${isAdminSubmenuOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                </button>
                {isAdminSubmenuOpen && (
                  <ul className="pl-6 mt-1 space-y-1">
                    <li><button onClick={() => navigateAndClose('certificado')} className={getSubMenuItemClasses('certificado')}>Certificados</button></li>
                    <li><button onClick={() => navigateAndClose('garantia')} className={getSubMenuItemClasses('garantia')}>Garantía</button></li>    
                    {/* --- INICIO WHATSAPP CHAT --- */}
                    <li> 
                      <button 
                        onClick={() => navigateAndClose('whatsapp-chat')} 
                        className={getSubMenuItemClasses('whatsapp-chat')}
                      >
                        Chat WhatsApp
                      </button>
                    </li>
                    {/* --- FIN WHATSAPP CHAT --- */}
                    <li><button onClick={() => navigateAndClose('owner-space')} className={getSubMenuItemClasses('owner-space')}>Espacio Personal</button></li>
                    <li><button onClick={() => navigateAndClose('users')} className={getSubMenuItemClasses('users')}>Usuarios</button></li>
                    <li><button onClick={() => navigateAndClose('inventory')} className={getSubMenuItemClasses('inventory')}>Inventario</button></li>
                  </ul>
                )}
              </li>
            )}

            {/* ===== BLOQUE ESPECIAL PARA CONTADOR ===== */}
            {isRoleContador && (
              <>
                {/* Acceso directo a Espacio Personal */}
                <li className="list-none">
                  <button
                    onClick={() => navigateAndClose('owner-space')}
                    className={getSubMenuItemClasses('owner-space')}
                  >
                    Espacio Personal
                  </button>
                </li>
              </>
            )}
            {/* ===== FIN BLOQUE ESPECIAL PARA CONTADOR ===== */}

            {/* Sucursales — siempre visible, pero para administrativo/contador es lo único de operaciones */}
            <li className="list-none">
              <button
                onClick={toggleSucursalesSubmenu}
                className={getMenuItemClasses('sucursales')}
              >
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20"><path d="M4 3a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1H4zm0 2h12v10H4V5zm2 2a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H7a1 1 0 01-1-1V7z"></path></svg>
                  Sucursales
                </div>
                <svg className={`w-4 h-4 transform transition-transform duration-200 ${isSucursalesSubmenuOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
              </button>
              {isSucursalesSubmenuOpen && (
                <ul className="pl-6 mt-1 space-y-1">
                  <li>
                    <button onClick={() => navigateAndClose('sucursales')} className={getSubMenuItemClasses('sucursales')}>
                      Corte de Cajas
                    </button>
                  </li>
                </ul>
              )}
            </li>

            {/* Ecommerce — oculto para administrativo y contador */}
            {(!isRoleAdministrativo && !isRoleContador) && (
              <li className="list-none">
                <button
                  onClick={toggleEcommerceSubmenu}
                  className={getMenuItemClasses('ecommerce-main')}
                >
                  <div className="flex items-center">
                    <svg className="w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20"><path d="M3 1a1 1 0 000 2h1.586l1.707 1.707A1 1 0 007 5h6a1 1 0 00.707-.293L16 2.414V17a1 1 0 001 1h2a1 1 0 001-1V3a1 1 0 00-1-1h-6.586l-1.707-1.707A1 1 0 0013 0H7a1 1 0 00-.707.293L4 2.414H3zM5 7a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1V8a1 1 0 00-1-1H5z"></path></svg>
                    Ecommerce
                  </div>
                  <svg className={`w-4 h-4 transform transition-transform duration-200 ${isEcommerceSubmenuOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                </button>
                {isEcommerceSubmenuOpen && (
                  <ul className="pl-6 mt-1 space-y-1">
                    <li>
                      <button onClick={() => navigateAndClose('ecommerce')} className={getSubMenuItemClasses('ecommerce')}>
                        Consulta de Pedidos
                      </button>
                    </li>
                    <li>
                      <button onClick={() => navigateAndClose('meli-metrics')} className={getSubMenuItemClasses('meli-metrics')}>
                        Analíticas Meli 📈
                      </button>
                    </li>
                    
                    <li>
                      <button onClick={toggleLogisticaSubmenu} className={getSubMenuItemClasses('logistica-container')}>
                        Logística
                        <svg className={`w-3 h-3 ml-2 inline transform transition-transform duration-200 ${isLogisticaSubmenuOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                      </button>
                      {isLogisticaSubmenuOpen && (
                        <ul className="pl-6 mt-1 space-y-1">
                          <li><button onClick={() => navigateAndClose('logistica')} className={getSubMenuItemClasses('logistica')}>Cuadre de Guías</button></li>
                          <li><button onClick={() => navigateAndClose('guide-management')} className={getSubMenuItemClasses('guide-management')}>Gestión de Guías</button></li>
                          <li><button onClick={() => navigateAndClose('picking')} className={getSubMenuItemClasses('picking')}>Picking (Local)</button></li>
                          <li><button onClick={() => navigateAndClose('picking-v2')} className={getSubMenuItemClasses('picking-v2')}>Picking Regional</button></li>
                          <li><button onClick={() => navigateAndClose('transfers')} className={getSubMenuItemClasses('transfers')}>Traspasos</button></li>
                        </ul>
                      )}
                    </li>
                    
                    {user?.rol === 'admin' && (
                      <li>
                        <button onClick={toggleAutoAzurSubmenu} className={getSubMenuItemClasses('autoazur-container')}>
                          AutoAzur
                          <svg className={`w-3 h-3 ml-2 inline transform transition-transform duration-200 ${isAutoAzurSubmenuOpen ? 'rotate-180' : ''}`} fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </button>
                        {isAutoAzurSubmenuOpen && (
                          <ul className="pl-6 mt-1 space-y-1">
                            <li><button onClick={() => navigateAndClose('autoazur-inventory-update')} className={getSubMenuItemClasses('autoazur-inventory-update')}>Actualizar Inventario</button></li>
                          </ul>
                        )}
                      </li>
                    )}
                    
                  </ul>
                )}
              </li>
            )}
            {/* === FIN Ecommerce === */}
          </ul>
          
          <div className="pt-4 border-t border-gray-700 mt-4">
            <button
              onClick={onLogout}
              className="flex items-center p-3 rounded-lg bg-red-600 hover:bg-red-700 transition duration-200 w-full justify-center"
            >
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 001 1h10a1 1 0 001-1V4a1 1 0 00-1-1H3zm2 2h8v10H5V5zm7 2a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 001-1V8a1 1 0 00-1-1h-2z" clipRule="evenodd"></path></svg>
              Cerrar Sesión
            </button>
          </div>
        </nav>
        </div>
      </aside>

      <main className="flex-1 min-h-screen p-6 w-full overflow-x-hidden">
        <header className="flex justify-between items-center bg-white p-4 rounded-lg shadow mb-6">
          <div className="flex items-center gap-3">
            {/* Hamburger button to open sidebar */}
            <button
              className="p-2 rounded-md border border-gray-200 hover:bg-gray-50 text-gray-700"
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              aria-label="Alternar menú"
              title="Menú"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
            </button>
            <img
              src={logoBlueRover}
              alt="BLUEROVER Header Logo"
              className="h-10 rounded-lg"
              onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/150x40/cccccc/333333?text=BLUEROVER" }}
            />
          </div>
          <div className="relative flex items-center">
            {/* Widget de Meli (burbujita) */}
            <MeliQuestionsWidget user={user} />

            <button
              onClick={toggleUserDropdown}
              className="flex items-center text-gray-700 hover:text-gray-900 focus:outline-none"
            >
              <svg className="w-6 h-6 inline-block mr-1" fill="currentColor" viewBox="0 0 20 20"><path d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" fillRule="evenodd"></path></svg>
              <span className="font-semibold mr-1">{user?.nombre || 'Usuario'}</span>
              <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
            </button>

            {isUserDropdownOpen && (
              <div className="absolute right-0 top-10 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
                <button onClick={(e) => { e.preventDefault(); navigateTo('my-account'); }} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Mi cuenta</button>
                
                {(!isRoleAdministrativo && !isRoleContador && user?.rol === 'admin') && (
                  <>
                    <button onClick={(e) => { e.preventDefault(); navigateTo('users'); }} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Configuración</button>
                    <button onClick={(e) => { e.preventDefault(); navigateTo('carriers'); }} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">📦 Paqueterías</button>
                    <button onClick={(e) => { e.preventDefault(); navigateTo('inventory'); }} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">📦 Inventario</button>
                  </>
                )}
                
                <button
                  onClick={onLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-red-700 hover:bg-red-100 border-t border-gray-200"
                >
                  Cerrar Sesión
                </button>
              </div>
            )}
          </div>
        </header>

        {children}
      </main>
    </div>
  );
}

export default AppLayout;